import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Button,
    Grid,
    Popper,
    TextField,
    FormControlLabel,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    MenuItem,
    InputLabel,
    Select,
    Typography,
    CircularProgress,
    Skeleton
} from '@mui/material';
import toast from 'react-hot-toast';
import countries from 'utils/countries_states.json';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';
import { isEmpty, validateAmount, validateEmail } from 'utils/validator';
import MainCard from 'ui-component/cards/MainCard';
import { get, post, put } from '../../axios/apiService';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import { Controller, useForm } from 'react-hook-form';
import { useMemo } from 'react';
import { styled } from '@mui/system';


const CustomPopper = styled(Popper)({
    '& .MuiAutocomplete-paper': {
        backgroundColor: '#f5f5f5',
        color: '#000'
    }
});

function AddEditContactForm({ title = '' }) {
    const theme = useTheme();
    const id = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [cusPage, setCusPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [cusOpen, setCusOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ id: '', label: '' });
    const [options, setOptions] = useState([]);


    const { control, handleSubmit, reset, getValues, watch } = useForm({
        defaultValues: {
            firstName: '',
            lastName: '',
            email: '',
            mobileNumber: '',
            alternateMobileNumber: '',
            relationShip: 0,
        }
    });

    const watchedFields = [
        'firstName',
        'lastName',
        'email',
        'mobileNumber',
        'alternateMobileNumber',
        'relationShip'
    ];
    const formValues = useMemo(() =>
        watchedFields.reduce((acc, field) => {
            acc[field] = watch(field);
            return acc;
        }, {}),
        watchedFields.map(watch)
    );


    const [formErrors, setFormErrors] = useState({});
    const [isValidation, setIsValidation] = useState(false);

    useEffect(() => {
        if (isValidation) {
            validator(formValues);
        }
    }, [formValues, isValidation]);

    useEffect(() => {
        if (id.id != undefined && id.id != null) {
            const getByIdCustomer = async () => {
                setIsLoading(true);
                try {
                    let response = await get(`Contact/${id.id}`, null);
                    if (response != null) {
                        let country = countryByName(response?.country);
                        let state = stateByName(country, response?.state);
                        reset({
                            firstName: response.firstName || '',
                            lastName: response.lastName || '',
                            email: response.email || '',
                            mobileNumber: response.mobileNumber || '',
                            alternateMobileNumber: response.alternate_MobileNumber,
                            relationShip: response.relationship,
                        });

                        getCustomerById(response.customerId);
                    }
                } catch (err) {
                    console.error(err.message);
                    toast.error(err.response.data);
                } finally {
                    setIsLoading(false);
                }
            };
            getByIdCustomer();
        }
    }, [id]);
    useEffect(() => {
        if (cusOpen && (!options || options?.length === 0)) {
            fetchCustomer();
        }
    }, [cusOpen]);


    const onSubmit = async (data) => {
        console.log("daataa", data);
        setIsValidation(true);
        if (!validator()) return;
        // setIsValidation(false);
        if (selectedOption.id == null || selectedOption.id == undefined || isEmpty(selectedOption.id)) {
            toast.error("Plese Select Customer");
            return;
        }

        const apiUrl = id.id != undefined && id.id != null ? `Contact/${id.id}` : 'Contact';

        let param = {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            mobileNumber: data.mobileNumber,
            alternate_MobileNumber: data.alternateMobileNumber,
            Relationship: data.relationShip,
            customerId: selectedOption.id
        };
        try {
            setIsLoading(true);
            let response = id.id ? await put(apiUrl, param) : await post(apiUrl, param);
            if (response) {
                if (id.id) {
                    toast.success(id.id ? 'Contact updated successfully' : 'Contact added successfully');
                } else {
                    toast.success(
                        `Customer added successfully`
                    );
                }
                navigate('/contact');
            }
        } catch (error) {
            toast.error(error?.response?.data);
        } finally {
            setIsLoading(false);
        }
    };

    const validator = () => {
        let data = getValues();
        const errors = {};
        if (isEmpty(data?.firstName)) {
            errors.firstName = "Please enter First name";
        }
        if (isEmpty(data?.lastName)) {
            errors.lastName = "Please enter Last name";
        }
        if (isEmpty(data?.email)) {
            errors.email = "Please enter email-id";
        }
        else if (!isEmpty(data?.email) && !validateEmail(data.email)) {
            errors.email = "Please enter a valid email";
        }
        else {
            delete errors.email;
        }


        if (!validateAmount(data?.relationShip, 1)) {
            errors.relationShip = "Please Select RelationShip";
        }


        let mobileNumber = data.mobileNumber.startsWith('+') ? data.mobileNumber : `+${data.mobileNumber}`;
        let phoneNumber = parsePhoneNumberFromString(mobileNumber);
        if (!phoneNumber || !phoneNumber.isValid()) {
            errors.mobileNumber = "Invalid Mobile Number";
        }
        // if (isEmpty(customer.mobileNumber ?? "")) {
        //   errors.mobileNumber = "Please Enter Mobile Number ";
        // } else if (!isValidPhoneNumber(customer.mobileNumber?.toString())) {
        //   errors.mobileNumber = "Invalid Phone Number";
        // } else {
        //   delete errors.mobileNumber;
        // }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const countryByName = (name) => {
        var country = countries?.find((x) => x.name == name);
        if (country != null) {
            return country;
        } else {
            return null;
        }
    };

    const stateByName = (country, name) => {
        var state = country?.states?.find(x => x.name == name);
        if (state != null) {
            return state;
        } else {
            return null;
        }
    }

    const relationOptions = [{
        value: 1,
        label: "Executor"
    }, {
        value: 2,
        label: "Beneficiary"
    }, {
        value: 3,
        label: "Emergency"
    }];

    const fetchCustomer = async () => {
        if (!hasMore) return; 

        setLoading(true);
        try {
            const response = await get(`Customer?page=${cusPage}&pageSize=99999`);
            const customerData = response?.values?.map((x) => {
                return { id: x.id, label: x.givenName };
            });

            if (customerData && customerData.length > 0) {
                setOptions((prevOptions) => [...prevOptions, ...customerData]);

                const totalCount = response.totalCount;
                const hasMoreData = cusPage * 10 < totalCount; 

                if (hasMoreData) {
                    setCusPage(cusPage + 1); 
                } else {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error('Error fetching customers:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleScroll = (event) => {
        const bottom = event.target.scrollHeight - event.target.scrollTop <= event.target.clientHeight + 1;
        if (bottom && hasMore && !loading) {
            fetchCustomer();
        }
    };

    const handleChangeCustomer = (event) => {
        const selectedId = event.target.value;
        const selectedLabel = options.find((option) => option.id === selectedId)?.label || '';
        setSelectedOption({ id: selectedId, label: selectedLabel });
    };

    const getCustomerById = async (id) => {
       await fetchCustomer();
        let response = await get(`Customer/${id}`, null);
        if (response != null) {
            console.log("response...", response);
            let newSelectedOption = {
                id: response.id,
                label: response.givenName
            }
            console.log("newSeelee...",newSelectedOption)
            setSelectedOption(newSelectedOption);
        }
    }

    console.log("selected OPtion..",selectedOption)

    return (
        <div>
            <MainCard title={title} backButton={{ onClick: () => navigate('/contact') }}>
                <Grid container spacing={2} sx={{ padding: '10px' }}>
                    <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
                        <InputLabel sx={{ fontWeight: 'bold', marginRight: '10px' }} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                            {selectedOption.id ? "Customer" : "Select Customer"}
                        </InputLabel>
                        <Select
                            open={cusOpen}
                            value={selectedOption.id || ''}
                            onChange={handleChangeCustomer}
                            onOpen={() => setCusOpen(true)}
                            onClose={() => setCusOpen(false)}
                            MenuProps={{
                                PaperProps: {
                                    onScroll: handleScroll,
                                    style: {
                                        maxHeight: 300,
                                        overflowY: 'auto'
                                    }
                                }
                            }}
                            renderValue={(selectedId) => {
                                if (!selectedId) {
                                    return 'Select a customer';
                                }
                                const selectedOptionLabel = options.find((option) => option.id === selectedId)?.label || 'Select a customer';
                                return selectedOptionLabel;
                            }}
                            sx={{ marginLeft: '10px', width: 200 }}
                        >
                            {options &&
                                options.map((option, index) => (
                                    <MenuItem key={index} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            {loading && (
                                <MenuItem disabled>
                                    <CircularProgress size={24} />
                                </MenuItem>
                            )}
                        </Select>
                    </Grid>
                </Grid>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        {/* Personal Information Section */}
                        <Grid item xs={12}>
                            <fieldset style={{
                                border: '2px solid #364152',
                                borderRadius: '8px',
                                padding: '20px',
                                marginBottom: '20px',
                            }}>
                                <legend style={{
                                    color: '#364152',
                                    fontSize: '1.2em',
                                    padding: '0 10px',
                                    fontWeight: 'bold',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '5px',
                                }}>
                                    Personal Information
                                </legend>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Typography sx={{ fontWeight: 'bold' }}>
                                                First Name
                                            </Typography>
                                            <Controller name="firstName" control={control} render={({ field }) => <TextField {...field} placeholder="First Name" fullWidth sx={{ marginTop: "5px" }} />} />
                                            <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Typography sx={{ fontWeight: 'bold' }}>
                                                Last Name
                                            </Typography>
                                            <Controller name="lastName" control={control} render={({ field }) => <TextField {...field} placeholder='Last Name' fullWidth sx={{ marginTop: "5px" }} />} />
                                            <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Typography sx={{ fontWeight: 'bold' }}>
                                                Email
                                            </Typography>
                                            <Controller name="email" control={control} render={({ field }) => <TextField {...field} placeholder="Email" fullWidth sx={{ marginTop: "5px" }} />} />
                                            <div style={{ color: 'red' }}>{formErrors.email}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Controller name="mobileNumber" control={control} render={({ field }) =>
                                                <>
                                                    <Typography sx={{ fontWeight: 'bold' }}>
                                                        Mobile Number
                                                    </Typography>
                                                    <PhoneInput
                                                        {...field}
                                                        country={'in'}
                                                        onChange={(value) => field.onChange(value)}
                                                        inputStyle={{
                                                            width: '100%',
                                                            height: '51px',
                                                            borderRadius: '12px',
                                                        }}
                                                        containerStyle={{ marginTop: "5px" }}
                                                    />
                                                </>
                                            } />
                                        </FormControl>
                                        <div style={{ color: 'red' }}>{formErrors.mobileNumber}</div>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Controller name="alternateMobileNumber" control={control} render={({ field }) =>
                                                <>
                                                    <Typography sx={{ fontWeight: 'bold' }}>
                                                        Alternate MobileNumber
                                                    </Typography>
                                                    <PhoneInput
                                                        {...field}
                                                        country={'in'}
                                                        onChange={(value) => field.onChange(value)}
                                                        inputStyle={{
                                                            width: '100%',
                                                            height: '51px',
                                                            borderRadius: '12px',
                                                        }}
                                                        containerStyle={{ marginTop: "5px" }}
                                                    />
                                                </>
                                            } />
                                        </FormControl>
                                        <div style={{ color: 'red' }}>{formErrors.alternateMobileNumber}</div>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Controller
                                            name="relationShip"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    <Typography sx={{ fontWeight: 'bold' }}>
                                                        RelationShip
                                                    </Typography>
                                                    <Select labelId="type-label" placeholder='Select RelationShip'  {...field} fullWidth sx={{ marginTop: "5px" }}>
                                                        {relationOptions &&
                                                            relationOptions.map((x, i) => (
                                                                <MenuItem value={x.value} key={i}>
                                                                    {x.label}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                </>
                                            )}
                                        />
                                        <div style={{ color: 'red' }}>{formErrors.relationShip}</div>
                                    </Grid>
                                </Grid>
                            </fieldset>
                        </Grid>
                    </Grid>

                    <Button type="submit" variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} >
                        Save
                    </Button>
                </form>
            </MainCard>


            <LoadingBackdrop open={isLoading} />
        </div>
    );
}
export default AddEditContactForm;
